import type { ErrorInfo } from 'react';
import type { TErrorContext } from '@cascade/core/errors';

export const toRenderContext = (info: ErrorInfo): TErrorContext => ({
  source: 'render',
  componentStack: info.componentStack ?? undefined,
});
